import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(theme => ({
  mainDiv: {
    width: "100%",
    display: "flex",
    flexDirection: "column"
  },
  searchBar: {
    marginBottom: "8px"
  },
  labelNotFound: {
    fontFamily: "Manrope",
    color: "#000",
    fontSize: "12px",
    margin: "10px 0px 0px 2px"
  }
}));

export default styles;
